import React, { useEffect } from "react";
import { Box, Button as MatButton, ButtonGroup, Grid2 } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import Button from "../../../../components/Button/Button";
import ViewTableWrapper from "../../../../shared/ViewTableWrapper/ViewTableWrapper";
import { useState } from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import UpcomingInterviewCalendar from "../../CandidateManagement/CandidateManagementView/components/UpcomingInterviewCalendar";
import API from "../../../../api/axios";
import ConfirmationDialog from "../../../../components/ConfirmationDialog/ConfirmationDialog";
import InterviewTrackerListView from "../../Interviewer/InterviewTrackerListing/InterviewTrackerListView";
import { getUser } from "../../../../utils/types";

const InterTracker: React.FC = () => {
  const navigate = useNavigate();
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const [switchView, setSwitchView] = useState<string>("list");
  const [reschedulePopupOpen, setReschedulePopupOpen] =
    useState<boolean>(false);
  const [interviewerCalendarData, setInterviewerCalendarData] = useState<any>(
    []
  );
  const state = useLocation();
   const loggedUserdata = getUser();
    const roleCode: string = loggedUserdata?.roles?.role_code ?? "";
    const isReschuldingTracker = state.pathname?.includes("rescheduling-tracker");

  useEffect(() => {
    if (state?.state?.view === "calendar") {
      setSwitchView("calendar");
    }
  }, [state?.state?.view]);

  const getCalenderData = async () => {
    try {
      let response = await API.post("/positions/all/applied", {
        offset: 0,
        limit: -1,
        dataType: "scheduled",
        viewType:"calendar"
      });
      let newData = response?.data?.data?.map((value: any) => {
        return {
          id: value?.id,
          title: value?.scheduled_applications[0]?.position_name,
          start: `${value?.scheduled_applications[0]?.slot_date}T${value?.scheduled_applications[0]?.start_time}`,
          end: `${value?.scheduled_applications[0]?.slot_date}T${value?.scheduled_applications[0]?.end_time}`,
          extendedProps: {
            ...value,
            webex_link: value?.scheduled_applications[0]?.webex_link,
          },
        };
      });
      setInterviewerCalendarData(newData);
    } catch (error) {
      // Failed to fetch interview tracker listing
    }
  };

  useEffect(() => {
    if (!isReschuldingTracker) {
      getCalenderData();
    } else {
      setSwitchView("list");
    }
  }, [isReschuldingTracker]);

  const calenderViewActionClick = (data: any) => {
    navigate(`/admin/interview-tracker/view/${data.id}`, {
      state: { ...data, view: "calendar" },
    });
  };

  const calenderViewAssessmentClick = (data: any) => {
    navigate(`/admin/interview-tracker/feed-back/${data.id}`, {
      state: { ...data, view: "calendar" },
    });
  };

  const handleReschedule = (data?: any) => {
    setReschedulePopupOpen(true);
  };

  const switchInterviewHandler = (type?: any) => setSwitchView(type);
  return (
    <>
      <PageWrapper>
        <Grid2 container>
          <Grid2 size={{xs: 12, sm: 6, md: 6}}>
            <PageHeader title={isReschuldingTracker ? "Rescheduling Tracker" : "Interview Tracker"} />
          </Grid2>
          <Grid2 size={{xs: 12, sm: 6, md: 6}} sx={{display: "flex", justifyContent: {xs: "flex-start", sm: "end"}}}>
            <ButtonGroup
              sx={{
                backgroundColor: "white",
                borderRadius: "20px",
                height: "40px",
                width: {xs: "100%", sm: "unset", md: "unset"},
                margin: {xs: "5px 0", sm: "0", md: "0"},
              }}
            >
              {
                roleCode !== "nhai_officials" && !isReschuldingTracker && (
                  <>
                    <MatButton
                sx={{
                  backgroundColor:
                  switchView === "list" ? "transparent" : "#F5F5F5",
                  color: "#000",
                  borderRadius: "50px 0 0 50px !important",
                  width: {xs: "50%", sm: "160px", md: "160px"},
                  
                  fontSize: {xs: "12px", md: "14px"},
                  height: "2.5rem",
                  border: "solid 1px #ddd",
                  fontWeight: 400,
                }}
                onClick={() => switchInterviewHandler("list")}
              >
                <CheckOutlinedIcon
                  sx={{
                    fontSize: "18px",
                    marginRight: ".4rem",
                    display: switchView === "list" ? "block" : "none",
                  }}
                />
                List View
              </MatButton>
              <MatButton
                sx={{
                  backgroundColor:
                  switchView === "calendar" ? "transparent" : "#F5F5F5",
                  color: "#000",
                  width: {xs: "50%", sm: "160px", md: "160px"},
                 
                  borderRadius: "0 50px 50px 0 !important",
                  fontSize: {xs: "12px", md: "14px"},
                  height: "2.5rem",
                  border: "solid 1px #ddd",
                  fontWeight: 400,
                }}
                onClick={() => switchInterviewHandler("calendar")}
              >
                <CheckOutlinedIcon
                  sx={{
                    fontSize: "18px",
                    marginRight: ".4rem",
                    display: switchView === "calendar" ? "block" : "none",
                  }}
                />
                Calendar View
              </MatButton>
                  </>
                )
              }
              
            </ButtonGroup>
          </Grid2>
        </Grid2>
        

        <Box marginTop={1}  className="interview-list-wrap">
          <ViewTableWrapper.Content sx={{
              padding: {xs: "0", md: "0"}
          }}> 
            {switchView === "list" ? (
              <Box m={0}>
                <InterviewTrackerListView key={isReschuldingTracker ? "attendance" : "interview"} />
              </Box>
            ) : (
              <Box sx={{ backgroundColor: "white", borderRadius: "15px" }} mt={2} p={2}>
                <UpcomingInterviewCalendar
                  data={interviewerCalendarData}
                  handleView={calenderViewActionClick}
                  rescheduleText="View-Assessment"
                  handleReschedule={calenderViewAssessmentClick}
                />
              </Box>
            )}
          </ViewTableWrapper.Content>
        </Box>
      </PageWrapper>
    </>
  );
};

export default InterTracker;
